<template>
  <div>
    <div v-if="!flowConfiguration" style="text-align: center"><span class="pt-3 texto-corrido-pequeno">Selecione uma opção na tabela acima</span></div>
    <div v-else>
      <v-row>
        <v-col class="pb-0">
          <span class="card-title pa-0">Opção {{ localMenuOptionConfiguration.active ? selectedMenuOptionPosition : 'desativada' }}</span>
        </v-col>
      </v-row>
      <v-row class="py-0">
        <v-col class="d-flex align-start" cols="12">
          <mf-toggle v-model="localMenuOptionConfiguration.active" class="pl-1" hide-details>
            <template v-slot:label>
              <span class="subtitle-bold-font">Opção ativa</span>
            </template>
          </mf-toggle>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="py-0">
          <span class="subtitle-bold-font">Título do menu</span>
          <mf-textarea-emoji
            v-model="localMenuOptionConfiguration.menu_name"
            outlined
            no-resize
            background-color="white"
            height="10"
            :max-length="0"
            :error-messages="menuNameError"
            hide-counter
          />
        </v-col>
      </v-row>
      <component :is="selectedFlowComponent" ref="flowConfiguration" :flow-configuration="flowConfiguration" @input="updateFlowConfiguration" />
    </div>
  </div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators'
import { notOnlySpace } from '@/helpers/validators.js'
import isEqual from 'lodash/isEqual'
import cloneDeep from 'lodash/cloneDeep'

export default {
  components: {
    FlowSimpleResponse: () => import('@/modules/campanhas/whatsapp/views/components/flow_configurations/FlowSimpleResponse.vue'),
    FlowForwardToSender: () => import('@/modules/campanhas/whatsapp/views/components/flow_configurations/FlowForwardToSender.vue'),
  },

  props: {
    selectedMenuOption: {
      type: Object,
    },
    selectedMenuOptionPosition: {
      type: Number,
    },
  },

  data: () => ({
    localMenuOptionConfiguration: {},
  }),

  computed: {
    flowConfiguration() {
      return this.localMenuOptionConfiguration?.flow
    },
    menuNameError() {
      if (this.$v.localMenuOptionConfiguration?.$error) {
        if (!this.$v.localMenuOptionConfiguration?.menu_name?.required) return 'Dê um nome para essa opção no menu.'
        if (!this.$v.localMenuOptionConfiguration?.menu_name?.minLength) return 'O nome no menu possui menos de 2 caracteres.'
        if (!this.$v.localMenuOptionConfiguration?.menu_name?.notOnlySpace) return 'Não é permitido salvar apenas espaços.'
      }
      return ''
    },
    selectedFlowComponent() {
      if (!this.localMenuOptionConfiguration?.flow?.handle) return 'FlowEmpty'
      const components = {
        simple_response: 'FlowSimpleResponse',
        forward_to_sender: 'FlowForwardToSender',
      }
      return components[this.localMenuOptionConfiguration?.flow?.handle]
    },
  },

  watch: {
    selectedMenuOption: {
      deep: true,
      handler(newVal) {
        if (!isEqual(newVal, this.localMenuOptionConfiguration)) {
          this.localMenuOptionConfiguration = cloneDeep(newVal)
        }
      },
    },

    localMenuOptionConfiguration: {
      deep: true,
      handler(newVal) {
        if (!isEqual(newVal, this.selectedMenuOption)) {
          this.$emit('input', newVal)
        }
      },
    },
  },

  mounted() {
    this.localMenuOptionConfiguration = cloneDeep(this.selectedMenuOption)
  },
  methods: {
    computeMessages() {
      if (this.$refs.flowConfiguration) {
        return this.$refs.flowConfiguration.computeMessages()
      }
      return []
    },
    updateFlowConfiguration(value) {
      console.log('Updating flow configuration', value)
      this.localMenuOptionConfiguration.flow = value
    },
    validate() {
      this.$v.$reset()
      this.$v.$touch()

      let flowConfigurationError = false
      if (this.$refs.flowConfiguration) {
        flowConfigurationError = this.$refs.flowConfiguration.validate()
      }

      return this.$v.$error || flowConfigurationError
    },
    isErrored() {
      return this.$v.$error || this.$refs.flowConfiguration?.$error
    },
  },

  validations() {
    if (this.flowConfiguration) {
      return {
        localMenuOptionConfiguration: {
          menu_name: {
            required,
            minLength: minLength(2),
            notOnlySpace,
          },
        },
      }
    }
    return {}
  },
}
</script>

<style lang="scss">
.emoji-textarea .v-input__append-inner {
  margin-top: 11px !important;
}
</style>
